class TalkAboutSlider extends HTMLElement {
  constructor() {
    super();

    const swiper = new Swiper(this.querySelector('.talk-about-swiper'), {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 30,
      mousewheel: {
        invert: false,
        forceToAxis: true,
      },

      // If we need pagination
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },

      // Navigation arrows
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },

      // And if we need scrollbar
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 3,
        },
        990: {
          slidesPerView: 4,
        }
      }
    });
  }
}

customElements.define('talk-about', TalkAboutSlider);